import React, { useRef } from 'react'
import { useState, useEffect } from 'react'

import './GradientDescent.css'
import * as d3 from 'd3'
import { index } from 'd3'

import { scaleSequential } from 'd3'
import { interpolateViridis } from 'd3-scale-chromatic'
import * as math from 'mathjs'
import { debounce } from 'lodash'
import { recordAPIAction, SubmitAnswerAPI, recordAPI } from '../../utils/recordSubmitAPI'


function parseFormula (formula) {
  try {
    const parsedFunction = new Function("x", `return ${formula}`)
    return parsedFunction
  } catch (error) {
    console.error('Formula parsing error:', error)
    return (x) => 0
  }
}
function sigmoid (x, a, b, c) {
  return `${c} * (1 / (1 + exp(-(${a} * ${x} + ${b}))))`
}


function parseFormulaForD (formula) {
  const math = require('mathjs')
  try {
    const parsedFunction = math.compile(formula)
    return parsedFunction
  } catch (error) {
    console.error('Formula parsing error:', error)
    return (x) => 0
  }
}
function ControlPanel (props) {
  const [xPoint, setXpoint] = useState(17.5)
  // const [epochs, setEpochs] = useState(50)
  const [formulaID, setFormulaID] = useState("0")
  const [formula, setFormula] = useState("(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.1^(x-16) + 2^(-(x+5))-exp(-2*(x-5)^2)")
  const [learningRate, setLearningRate] = useState(0.1)
  const [optimizer, setOptimizer] = useState("0")
  const [momentum, setMomentum] = useState(0.9)
  const [decayValue, setDecayValue] = useState(0.9)




  const generateInputBox = (name, index, element_id) => {
    // 設定參數變更的事件
    const handleOnChange = (event) => {


      // recordAPIAction("SelectionOnChangeRecord", element_id, localStorage.getItem('userUUID'))
      recordAPI("3-4", "Optimizer_Practice", element_id, event.target.value, Date(), localStorage.getItem('userUUID'))
      const newValue = event.target.value === "" ? 0.1 : event.target.value
      props.setPrevXpoint([1])

      switch (index) {
        case 0:
          setXpoint(newValue)
          props.setXpoint(newValue)
          break
        case 1:
          props.setEpochs(newValue)
          break
        case 2:
          setLearningRate(parseFloat(newValue))
          break
        case 3:
          setOptimizer(newValue)
          break
        case 4:
          setMomentum(newValue)
          break
        case 5:
          setDecayValue(newValue)
          break
        case 6:
          if (newValue === "0") {

            // props.setFormula("x^2 / 10 + x + 4")
            setXpoint(17.5)
            setFormulaID("0")
            // setFormula(`(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.1^(x-16) + 2^(-(x+5))-exp(-2*(x-5)^2)`)


          }
          else if (newValue === "1") {
            setFormulaID("1")
            // setFormula(`(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.1^(x-16) + 2^(-(x+5))-exp(-2*(x-5)^2)`)
            setXpoint(-8)
          }
          else {
            props.setFormula(`(${sigmoid("x", 0.4, -9.5, 30)}  - ${sigmoid("x", 0.3, -5, 13)} + ${sigmoid("x", 0.8, -8.5, 30)} - ${sigmoid("x", 0.25, 5, 25)} + 28) / 1.2`)
          }
          //  - ${sigmoid("x", 1.1, 10, 10)} - ${sigmoid("x", 1, -6, 10)}
          console.log(props.formula)
          break
        default:
          break
      }
    }

    const getValue = () => {
      switch (index) {
        case 0:
          return xPoint
        case 1:
          return props.epochs
        case 2:
          return learningRate
        case 3:
          return optimizer
        case 4:
          return momentum
        case 5:
          return decayValue
        case 6:
          return formulaID
        default:
          break
      }
    }

    const inputBox =
      index === 3 ? (
        <select
          className="input-box"
          onChange={handleOnChange}
          value={getValue()}
        >
          <option value="0">Gradient Descent</option>
          <option value="1">Momentum</option>
          <option value="2">RMSprops</option>
          <option value="3">Adam</option>

        </select>
      ) : index === 6 ? (

        <select
          className="input-box"
          onChange={handleOnChange}
          value={getValue()}
        >
          <option value="0">任務1</option>
          <option value="1">任務2</option>
          {/* <option value="2">任務3</option> */}
          {/* <option value="3">任務4</option> */}

        </select>
      ) : (
        // 数字输入框
        <input
          className="input-box"
          type="number"
          step={0.01}
          max={0.999}
          min={0}
          value={getValue()}
          onChange={handleOnChange}
        />
      )

    return (
      <div className="input-container" key={index}
        style={{
          display: (
            (optimizer === "0" && (index === 4 || index === 5)) || // Gradient Descent
            (optimizer === "1" && (index === 5)) || // Momentum
            (optimizer === "2" && (index === 4)) // RMSprop
          )
            ? "none"
            : "block"
        }}
      >
        <div className="input-box-name">{name}</div>
        {inputBox}
      </div>
    )
  }




  return (
    <div className="control-pannel-container">
      {generateInputBox("任務", 6, "TaskId")}
      {generateInputBox("優化器", 3, "OptimizerId")}

      {/* {generateInputBox("初始值", 0)} */}
      {/* {generateInputBox("Epochs", 1)} */}
      {generateInputBox("學習率", 2, "LearningRateId")}
      {generateInputBox("動量值", 4, "MomentumId")}
      {generateInputBox("衰減率", 5, "DecayValueId")}
      <button
        className="apply-button bg-black btn-dark text-white rounded-pill h-100"
        onClick={() => props.updateAllParameter(props.xPoint, props.epochs, learningRate, optimizer, xPoint, momentum, decayValue)}
      >
        套用
      </button>


    </div>
  )
}

function DescriptionArea () {
  return (
    <div className='descritpion-container'>
      機器人一號想透過訓練模型預測人的體脂率，為了提升模型的準確性，試著調整不同的權重參數，觀察這些變化對於模型損失值的影響。
    </div>
  )
}


function ProgressControlPanel (props) {
  const [forwardEpochs, setForwardEpochs] = useState(1)

  const [formula, setFormula] = useState("x * x + x + 1")
  const [prevClickTime, setPrevClickTime] = useState(0)

  const [xPoint, setXPoint] = useState(1)
  const [prevXpoint, setPrevXpoint] = useState([1])



  const handleForward = () => {

    // recordAPIAction("progressForwardRecord", "progressForwardId", localStorage.getItem('userUUID'))
    recordAPI("3-4", "Optimizer_Practice", "progressForwardRecord", null, Date(), localStorage.getItem('userUUID'))

    const math = require('mathjs')
    const learningRate = (props.learningRate)



    const node = math.parse(props.formula)
    const derivativeNode = math.derivative(node, 'x')

    const derivativeCompiled = derivativeNode.compile()


    let newXpoint = props.xPoint


    let pointList = []

    // Momentum
    let beta1 = props.momentum
    let prevV = props.prevMoementum[props.prevMoementum.length - 1]
    let MList = []

    // RMSProps
    let RMSList = []
    let prevSquaredGradient = props.prevSquaredGradient[props.prevSquaredGradient.length - 1]

    // Adam
    const beta2 = props.decayValue // RMSprop 的衰减率
    const epsilon = 1e-8


    for (let i = 0; i < forwardEpochs; i++) {
      const derivativeResult = derivativeCompiled.evaluate({ x: newXpoint })
      if (parseInt(props.optimizer) === 0) {

        newXpoint = newXpoint - derivativeResult * learningRate
        // console.log(newXpoint)
      } else if (parseInt(props.optimizer) === 1) {
        console.log("1111")

        const m = beta1 * prevV + derivativeResult * learningRate

        newXpoint = newXpoint - m

        MList = [...MList, m]
        prevV = m
        // props.setPrevMoementum((prev) => [...prev, v]);
      } else if (props.optimizer === "2") {
        // RMSprop

        const epsilon = 1e-8
        const decayRate = props.decayValue

        const gradient = derivativeResult
        const squaredGradient = gradient * gradient


        const movingAvgSquaredGradient = decayRate * prevSquaredGradient + (1 - decayRate) * squaredGradient
        console.log("movingAvgSquaredGradient", movingAvgSquaredGradient)


        newXpoint = newXpoint - learningRate * gradient / Math.sqrt(movingAvgSquaredGradient + epsilon)

        RMSList = [...RMSList, movingAvgSquaredGradient]
        prevSquaredGradient = movingAvgSquaredGradient

        // props.setPrevSquaredGradient(((prev) => [...prev, movingAvgSquaredGradient]));
      } else if (parseInt(props.optimizer) === 3) {
        // Adam

        // const beta1 = props.momentum; // momentum 的衰减率
        // const beta2 = props.decayValue; // RMSprop 的衰减率
        // const epsilon = 1e-8;


        const gradient = derivativeResult
        const squaredGradient = gradient * gradient

        const prevMomentum = prevV
        const momentum = beta1 * prevMomentum + (1 - beta1) * gradient
        MList = [...MList, momentum]
        prevV = momentum
        // props.setPrevMoementum((prev) => [...prev, momentum]);


        const movingAvgSquaredGradient = beta2 * prevSquaredGradient + (1 - beta2) * squaredGradient
        RMSList = [...RMSList, movingAvgSquaredGradient]
        prevSquaredGradient = movingAvgSquaredGradient
        // props.setPrevSquaredGradient((prev) => [...prev, movingAvgSquaredGradient]);

        const correctedMomentum = momentum / (1 - Math.pow(beta1, props.prevMoementum.length + MList.length - 1))
        const correctedMovingAvgSquaredGradient = movingAvgSquaredGradient / (1 - Math.pow(beta2, props.prevSquaredGradient.length + RMSList.length - 1))

        newXpoint = newXpoint - learningRate * correctedMomentum / (Math.sqrt(correctedMovingAvgSquaredGradient) + epsilon)
      } else {

        console.error("Unknown optimizer value:", props.optimizer)
      }
      pointList = [...pointList, newXpoint]
    }

    if (parseInt(props.optimizer) === 1) {
      props.setPrevMoementum((prev) => [...prev, ...MList])
    }
    else if (parseInt(props.optimizer) === 2) {
      props.setPrevSquaredGradient(((prev) => [...prev, ...RMSList]))
    }
    else if (parseInt(props.optimizer) === 3) {
      props.setPrevMoementum((prev) => [...prev, ...MList])
      props.setPrevSquaredGradient(((prev) => [...prev, ...RMSList]))
    }

    props.setXPoint(newXpoint)
    props.setPrevXpoint((prev) => [...prev, ...pointList])
    // props.setXPoint(newXpoint);
    // props.setPrevXpoint((prev) => [...prev, newXpoint]);
    // setXPoint(newXpoint);
  }

  const handleBackward = () => {
    if (props.prevXpoint.length > 1) {
      // props.setXPoint(prevXpoint[prevXpoint.length - 2]); // get the second to last element
      props.setXPoint(props.prevXpoint[props.prevXpoint.length - 2])
      props.setPrevXpoint((prev) => prev.slice(0, -1)) // remove the last element
      //Handle Momentum Backward
      if (props.optimizer === "1" && props.prevMoementum.length > 1) {
        props.setPrevMoementum((prev) => prev.slice(0, -1))
      }
    } else {
      console.log("Cannot go backward, not enough elements in prevXpoint")
    }

  }

  return (
    <div className='progress-control-container'>
      {<button className='progress-button' onClick={handleForward}>➡️</button>}
      {/* <button className='progress-button' onClick={handleForward}>⬅️</button>
        <button className='progress-button' onClick={handleBackward}>➡️</button> */}
      <div className='epoch-count w-150'>epoch: {props.prevXpoint.length}
      </div>

      <div className='progress-label'>向前步數:</div>
      <input className='progress-input' value={forwardEpochs} type="number" onChange={(event) => { setForwardEpochs(event.target.value) }} />


    </div>
  )
}



function generateNumbersWithSum (targetSum, count) {
  if (count <= 0 || targetSum <= 0) {
    console.error("輸入參數應為正數且數量應大於零")
    return []
  }

  const numbers = []

  for (let i = 0; i < count - 1; i++) {
    const randomNumber = Math.random() + Math.random() * 0.05 // 加入一些誤差
    numbers.push(randomNumber)
  }

  const total = numbers.reduce((acc, num) => acc + num, 0)
  const normalizedNumbers = numbers.map((num) => num / total)
  const scaledNumbers = normalizedNumbers.map((num) => num * targetSum)
  const GTList = normalizedNumbers.map(() => Math.random() * 10)
  const PredictList = GTList.map((num, index) => num + scaledNumbers[index])

  return { scaledNumbers, GTList, PredictList }
}

const GradientDivs = (props) => {
  const [loss, setLoss] = useState("-")
  const [predictValue, setPredictValue] = useState("-")
  const [groundTrue, setGroundTrue] = useState("-")
  const [selectedElement, setSelectedElement] = useState(null)

  const [divValues, setDivValues] = useState([])
  const [predictList, setPredictList] = useState([])
  const [GTList, setGTList] = useState([])

  useEffect(() => {
    const targetSum = props.loss.toFixed(3)
    const count = 100
    const { scaledNumbers, GTList, PredictList } = generateNumbersWithSum(
      targetSum,
      count
    )

    setDivValues(scaledNumbers)
    setGTList(GTList)
    setPredictList(PredictList)

  }, [props.loss])

  const lossOnClick = (event, index, value) => {
    recordAPI("3-4", "Optimizer_Practice", event.target.id, value, Date(), localStorage.getItem('userUUID'))
    setLoss(divValues[index].toFixed(3))
    setPredictValue(predictList[index].toFixed(3))
    setGroundTrue(GTList[index].toFixed(3))
    setSelectedElement(index)
  }

  return (
    <>
      <div className="data-container">
        <div className='data-description'>以下每個欄位代表資料庫中，一筆數據的損失值。試著觀察在不同的權重下，對預測體脂率的損失值有什麼變化。</div>
        <div className='data-loss-description text-center'>總資料集損失值: {props.loss.toFixed((4))}</div>
        <div className="loss-detail-container">
          <div className='text-center'>單筆資料</div>
          <div className='d-flex w-100 justify-content-center'>
            <div className="loss-container">損失值: {loss}</div>
            <div className="predict-container">預測值: {predictValue}</div>
            <div className="ground-container">正確值: {groundTrue}</div>
          </div>
        </div>

        {divValues.map((value, index) => {
          const opacity = 1 - value / 0.08
          const greenColor = `rgba(0, 255, 0, ${opacity.toFixed(3)})`

          return (
            <div
              key={index}
              id={`itemLoss${index}`}
              className={`gradient-div ${selectedElement === index ? 'selected' : ''}`}
              style={{
                backgroundColor: greenColor,
              }}
              onClick={(event) => lossOnClick(event, index, value)}
            >
              {value.toFixed(3)}
            </div>
          )
        })}
        <div className="color-map w-100">
          <div className="color-map-label">損失值顏色映射:</div>
          <div className="color-map-gradient">
            {Array.from({ length: 12 }).map((_, index) => {
              const value = (index) * 0.01
              const opacity = 1 - value / 0.08
              const greenColor = `rgba(0, 255, 0, ${opacity.toFixed(3)})`

              return (
                <div
                  key={index}
                  className="color-map-bar"
                  style={{
                    backgroundColor: greenColor,
                  }}
                >
                  {(index) % 0.5 === 0 ? value.toFixed(2) : ""}
                </div>
              )
            })}
          </div>
        </div>
      </div>



    </>
  )
}


function GDVisulization (props) {
  const svgRef = useRef(null)
  const debouncedRecordAPIActionRef = useRef(null)

  // Initialize zoom state and set it as a state variable
  const [zoomState, setZoomState] = useState(d3.zoomIdentity)
  useEffect(() => {
    const debouncedRecordAPIAction = debounce(() => {
      recordAPIAction("MathGraph", "id", localStorage.getItem('userUUID'))
    }, 1000)
    debouncedRecordAPIActionRef.current = debouncedRecordAPIAction
  }, [])




  useEffect(() => {
    const math = require('mathjs')

    const svg = d3.select(svgRef.current)
    const width = +svg.attr('width')
    const height = +svg.attr('height')

    // const formula = math.parse(props.formula)
    // const compiledFormula = formula.compile()
    const debouncedRecordAPIAction = debouncedRecordAPIActionRef.current
    const loss = props.compiledFormula.evaluate({ x: props.xPoint })

    props.setLoss(loss)

    svg.selectAll('*').remove()


    const x = d3.scaleLinear()
      .domain([-10, 24])
      .range([-1, width + 1])

    const y = d3.scaleLinear()
      .domain([21, 1])
      .range([-1, height + 1])

    const xAxis = d3.axisBottom(x)
      .ticks(((width + 2) / (height + 2)) * 10)
      .tickSize(height)
      .tickPadding(-12)

    const yAxis = d3.axisRight(y)
      .ticks(10)
      .tickSize(width)
      .tickPadding(8 - width)

    const lineGenerator = d3
      .line()
      .x(d => x(d.x))
      .y(d => y(d.y))

    const gX = svg.append("g")
      .attr("class", "axis axis--x")
      .call(xAxis)


    const point = svg.append("circle")
      .attr('cx', x(props.xPoint))
      .attr('cy', y(loss))
      .attr('r', 10)



    gX.selectAll("line")
      .style("opacity", 0.2)

    const gY = svg.append("g")
      .attr("class", "axis axis--y")
      .call(yAxis)


    gY.selectAll("line")
      .style("opacity", 0.2)


    // console.log(d3.range(-300, 300, 0.01).map((x) => ({ x, y: compiledFormula.evaluate({ x: x }) })))
    const pathF = svg.append("g")
      .append('path')
      .datum(d3.range(-20, 24.5, 0.1).map((x) => ({ x, y: props.compiledFormula.evaluate({ x: x }) })))
      .attr('fill', 'none')
      .attr('stroke', 'blue')
      .attr('stroke-width', 2)
      .attr('d', lineGenerator)

    const zoom = d3.zoom()
      .scaleExtent([1, 8])
      .translateExtent([[-400, -400], [width + 400, height]])
      .filter(filter)
      .on("zoom", zoomed)

    // Restore the saved zoom state
    svg.call(zoom.transform, zoomState)

    function zoomed (event) {
      const { transform } = event
      gX.call(xAxis.scale(transform.rescaleX(x)))
      gY.call(yAxis.scale(transform.rescaleY(y)))

      gX.selectAll("line")
        .style("opacity", 0.2)
      gY.selectAll("line")
        .style("opacity", 0.2)

      pathF.attr("stroke-width", 2 / transform.k)
      pathF.attr("transform", transform)
      point.attr("r", 5 / transform.k)
      point.attr("transform", transform)

      // Save the current zoom state
      setZoomState(transform)
      debouncedRecordAPIAction()
    }

    function reset () {
      svg.transition()
        .duration(750)
        .call(zoom.transform, d3.zoomIdentity)
    }

    function filter (event) {
      event.preventDefault()
      return (!event.ctrlKey || event.type === 'wheel') && !event.button
    }

    svg.call(zoom)

  }, [props.xPoint, props.formula])

  return (
    <div>
      <div className='gd-lable-container'>
        <div className='gd-x-label'>損失值</div>
        <svg
          className='gradient-descent-network-graph'
          ref={svgRef}
          width={1000}
          height={700}
          style={{ border: '1px solid gray' }}
        ></svg>
      </div>
      <div className='gd-y-label'>權重W</div>
    </div>
  )
}

function PracticeArea () {

  const [q1selectedOptions, setQ1SelectedOptions] = React.useState([])
  const [q2selectedOptions, setQ2SelectedOptions] = React.useState([])
  // const [q3selectedOptions, setQ3SelectedOptions] = React.useState([]);
  const [q3Answer, setQ3Answer] = React.useState("")


  const handleOptionChange = (event, setFunction) => {
    const option = event.target.value
    if (event.target.checked) {
      setFunction((prevOptions) => [...prevOptions, option])
    } else {
      setFunction((prevOptions) =>
        prevOptions.filter((prevOption) => prevOption !== option)
      )
    }
  }


  return (
    <div className='question-section'>
      <div className='sub-bullet-point'> • 練習問題</div>
      <div className='question-container '>
        <div className='question-title'>1. 那些優化器可以在任務1中，讓損失值下降到2.5以下?</div>
        <div className="optimization-options">
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="gradientDescent"
              onChange={(event) => handleOptionChange(event, setQ1SelectedOptions)}
            />
            Gradient Descent
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="rmsprop"
              onChange={(event) => handleOptionChange(event, setQ1SelectedOptions)}
            />
            RMSprop
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="momentum"
              onChange={(event) => handleOptionChange(event, setQ1SelectedOptions)}
            />
            Momentum
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="adam"
              onChange={(event) => handleOptionChange(event, setQ1SelectedOptions)}
            />
            Adam
          </label>
        </div>
        <button
          onClick={() => {
            if (window.confirm("確定要提交嗎？")) {
              SubmitAnswerAPI(
                "3-4",
                "Optimizer_Practice",
                "1",
                q1selectedOptions,
                Date(),
                localStorage.getItem('userUUID'))
            }
          }}
        >
          提交</button>
      </div>
      <div className='question-container '>
        <div className='question-title'>2. 那些優化器可以在任務2中，讓損失值下降到2.5以下?</div>
        <div className="optimization-options">
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="gradientDescent"
              onChange={(event) => handleOptionChange(event, setQ2SelectedOptions)}
            />
            Gradient Descent
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="rmsprop"
              onChange={(event) => handleOptionChange(event, setQ2SelectedOptions)}
            />
            RMSprop
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="momentum"
              onChange={(event) => handleOptionChange(event, setQ2SelectedOptions)}
            />
            Momentum
          </label>
          <label>
            <input
              type="checkbox"
              name="optimizer"
              value="adam"
              onChange={(event) => handleOptionChange(event, setQ2SelectedOptions)}
            />
            Adam
          </label>
        </div>
        <button
          onClick={() => {
            if (window.confirm("確定要提交嗎？")) {
              SubmitAnswerAPI(
                "3-4",
                "Optimizer_Practice",
                "2",
                q2selectedOptions,
                Date(),
                localStorage.getItem('userUUID'))
            }
          }}

        >
          提交</button>
      </div>
      <div className='question-container '>
        {/* <div className='question-title'>3. 在任務1和任務2中，試圖尋找一組參數組合，使模型在最少的訓練週期（Epochs）內，能夠達到損失值低於2.5。(待修改)</div> */}
        <div className='question-title'>3. 在學習率為0.1的情況下，請嘗試使用不同的參數，以使損失值在任務1或任務2中都能降至最低。然後請嘗試解釋你選擇這些參數的原因。<br></br>
          回答格式：<br></br>
          優化器： RMSprop, DecayValue: 0.9...<br></br>
          原因： ....
        </div>
        <textarea
          className='input-ans-area'
          value={q3Answer}
          onChange={(event) => setQ3Answer(event.target.value)}
        />
        <button
          onClick={() => {
            if (window.confirm("確定要提交嗎？")) {
              SubmitAnswerAPI(
                "3-4",
                "Optimizer_Practice",
                "3",
                q3Answer,
                Date(),
                localStorage.getItem('userUUID'))
            }
          }}

        >
          提交</button>
      </div>
    </div>
  )
}



function CH3_4GradientDescentSection () {
  // const [formula, setFormula] = useState("x*x + x + 1")

  // const [formula, setFormula] = useState(`(${sigmoid("x", 0.4, -9.5, 30)}  - ${sigmoid("x", 0.3, -5, 13)} + ${sigmoid("x", 0.8, -8.5, 30)} - ${sigmoid("x", 0.25, 5, 25)} + 28) / 1.2`)
  // const [formula, setFormula] = useState(`(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.5^(x-16) + 2^(-(x+5))`)
  const [formula, setFormula] = useState(`(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.5^(x-16) + 2^(-(x+5))-exp(-2*(x-5)^2)`)
  // `(10 / (1 + exp(x)) + 3 / (1 + exp(-(1 * x + 5))))  + 1.5^(x-16) + 2^(-(x+5))-exp(-2*(x-5)^2)`


  const [xPoint, setXpoint] = useState(17.5)
  const [compiledFormula, setCompiledFormula] = useState(math.parse(formula).compile())
  const [epochs, setEpochs] = useState(50)
  const [learningRate, setLearningRate] = useState(0.1)
  const [optimizer, setOptimizer] = useState("0")
  const [prevXpoint, setPrevXpoint] = useState([1])
  const [loss, setLoss] = useState(10)

  const [momentum, setMomentum] = useState(0.9)
  const [decayValue, setDecayValue] = useState(0.9)

  //Optimizer
  const [prevMoementum, setPrevMoementum] = useState([0])
  const [prevSquaredGradient, setPrevSquaredGradient] = useState([0])

  const updateAllParameter = (point, epochs, lr, s_optimizer, oriXpoint, s_momentum, s_decay) => {
    setXpoint(parseInt(oriXpoint))
    setEpochs(epochs)
    setLearningRate(lr)
    setOptimizer(s_optimizer)
    setPrevXpoint([oriXpoint])
    setMomentum(s_momentum)
    setPrevMoementum([0])
    setDecayValue(s_decay)
    setPrevSquaredGradient([0])
  }

  return (
    <>
      {/* <DescriptionArea></DescriptionArea> */}
      <div className='title-container'>
        <div className='title'>優化器練習</div>
        <div className='subtitle'>Optimizer Practice</div>
      </div>
      <div className="bullet-point"> • 模擬說明</div>
      <div className='simulation-description'>小海狸正在訓練一個預測體脂率的模型，他希望通過嘗試不同的優化器來降低模型的損失值。請試著操作下方的模擬，以幫助小海狸解決問題。完成後，請回答下方的練習問題。</div>

      <div className='gd-control-panel-container'>
        <ControlPanel
          formula={formula}
          setFormula={setFormula}
          updateAllParameter={updateAllParameter}
          xPoint={xPoint}
          setXpoint={setXpoint}
          prevXpoint={prevXpoint}
          setPrevXpoint={setPrevXpoint}
          epochs={epochs}
          setEpochs={setEpochs}
          learningRate={learningRate}
          setLearningRate={setLearningRate}
          optimizer={optimizer}
          setOptimizer={setOptimizer}
          momentum={momentum}
          setMomentum={setMomentum}
          decayValue={decayValue}
          setDecayValue={setDecayValue}
        >
        </ControlPanel>
      </div>
      <div className='main-vis-container d-flex justify-content-center align-items-center flex-column'>
        <div className="practice-bullet-point text-center">
          {optimizer === "0" ? "Gradient Descent" :
            optimizer === "1" ? "Momentum" :
              optimizer === "2" ? "RMSprop" :
                optimizer === "3" ? "Adam" :
                  "Unknown Optimizer"} <br />
          lr: {learningRate}, momentum: {optimizer === "1" || optimizer === "3" ? momentum : "-"}, decay: {optimizer === "2" || optimizer === "3" ? decayValue : "-"}

        </div>
        <ProgressControlPanel
          formula={formula}
          setFormula={setFormula}
          xPoint={xPoint}
          setXPoint={setXpoint}
          prevXpoint={prevXpoint}
          setPrevXpoint={setPrevXpoint}
          epochs={epochs}
          setEpochs={setEpochs}
          learningRate={learningRate}
          setLearningRate={setLearningRate}
          optimizer={optimizer}
          setOptimizer={setOptimizer}
          momentum={momentum}
          setMomentum={setMomentum}
          decayValue={decayValue}
          setDecayValue={setDecayValue}
          prevMoementum={prevMoementum}
          setPrevMoementum={setPrevMoementum}
          prevSquaredGradient={prevSquaredGradient}
          setPrevSquaredGradient={setPrevSquaredGradient}
        ></ProgressControlPanel>

        <div className='d-flex'>
          <GradientDivs
            xPoint={xPoint}
            formula={formula}
            prevXpoint={prevXpoint}
            loss={loss}
            setLoss={setLoss}
          ></GradientDivs>

          <GDVisulization
            formula={formula}
            xPoint={xPoint}
            loss={loss}
            setLoss={setLoss}
            compiledFormula={compiledFormula}

          ></GDVisulization>
        </div>

      </div>
      <PracticeArea></PracticeArea>

    </>
  )

}


export default CH3_4GradientDescentSection